// extracted by mini-css-extract-plugin
export var hideEditor = "_li-2";
export var infoIcon = "_li-3";
export var label = "_li-1";
export var labelContainer = "_li-0";
export var readonlyText = "_li-4";